import { useUser } from "@clerk/nextjs";
import { useFeatureFlagEnabled } from "posthog-js/react";
import { useLocalStorage } from "usehooks-ts";
import { MFA_ENROLLMENT_PROMPT_DISMISSED_KEY_PREFIX, MFA_ENROLLMENT_PROMPT_FEATURE_FLAG } from "@remi/constants";

import { useUserProfile } from "~/contexts/UserProfileContext";

const CAMPAIGN_VERSION = 1;
const DISMISS_DURATION_MS = 24 * 60 * 60 * 1000;

export const useMfaEnrollmentPrompt = () => {
  const { user, isLoaded } = useUser();
  const { user: profile } = useUserProfile();
  const actorId = profile.imposterId ?? profile.personId;
  const flagEnabled = useFeatureFlagEnabled(MFA_ENROLLMENT_PROMPT_FEATURE_FLAG);

  const storageKey = `${MFA_ENROLLMENT_PROMPT_DISMISSED_KEY_PREFIX}:${actorId}:v${CAMPAIGN_VERSION}`;
  const [dismissedAt, setDismissedAt] = useLocalStorage<number | null>(storageKey, null);

  const isDismissed = dismissedAt !== null && Date.now() - dismissedAt < DISMISS_DURATION_MS;
  const isEnrolled = user?.twoFactorEnabled === true;
  const needsCredentials = user?.passwordEnabled === false;

  const shouldShow = isLoaded && flagEnabled === true && !isEnrolled && !isDismissed;

  const dismiss = () => {
    setDismissedAt(Date.now());
  };

  return { shouldShow, dismiss, needsCredentials };
};
